import React from 'react';
import {Card, Icon,Label} from "semantic-ui-react";
import PageHeader from "../../components/page-header";
import './style.scss';

export default class PetOwner extends React.Component {
    createCard = () => {
        return (<Card>
            <div className={"owner-image"}>
            <Card.Content>
                <Card.Header ><img src={require("../../images/Background.png")} /></Card.Header>
                <div className={"username"}><Card.Header>Daniel</Card.Header><Card.Meta>Pet Owner</Card.Meta></div>
            </Card.Content>
            <Card.Content>
                <div className={"user-info"}>
                    <h4>Personal Info</h4>
                    <h5>Pet owner
                    <Icon name={"user circle outline"} size={"large"}/>
                    </h5>
                    <hr/>
                    <h4>Become a Sitter or Walker</h4>
                    <h5>Pet Sitter or Walker
                    <Icon name={"paw"} size={"large"} />
                    </h5>
                    <hr/>
                    <h4>Notification Settings</h4>
                    <h5>Change sound, ringtone settings
                        <Icon name={"settings"} size={"large"} />
                    </h5>
                    <hr />
                    <h4>Support</h4>
                    <h5>Guide
                        <Icon name={"help circle"} size={"large"} />
                    </h5>
                    <hr/>
                    <h4>Feedback</h4>
                    <h5>Feedback on the app
                        <Icon name={"feed"} size={"large"} />

                    </h5>
                    <hr/>
                    <h4>Terms of services</h4>
                    <h5>Users agreement
                        <Icon name={"question circle outline"} size={"large"} />
                    </h5>
                    <hr/>
                    <h4>Log off</h4>
                    <h5>See you soon
                        <Icon name={"log out"} size={"large"} />
                    </h5>


                </div>
            </Card.Content>
            </div>
        </Card>);
    }

    render() {
        return (
            <div>
                <PageHeader text='Available dogs' history={this.props.history}/>
                <div className={'get-pet'}>
                    {this.createCard()}
                </div>
            </div>
        );

    }

}
